export default function (http) {
    return {


        queryByPage(data) {
            return http.json({
                url: `/sys/informationStu/query?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            });
        },

        getInfo(data) {
            return http.json({
                url: `/sys/informationStu/get?id=${data.id}`,
                data
            })
        },

        saveInfo(data) {
            return http.json({
                url: `/sys/informationStu/save`,
                data
            })
        },
        getOne(data) {
            return http.json({
                url: `/sys/informationStu/getOne`,
                data
            })
        },


        delete(data) {
            return http.json({
                url: `/sys/informationStu/delete`,
                data
            })
        },
    }
}





// WEBPACK FOOTER //
// ./src/configure/http/api/enroll/informationStudent.js